import { useEffect } from 'react';
import userAgentDetect from '../../util/userAgentDetect';
import {
  CART_NEWRELIC_BROWSER_AGENT_IDENTIFIER,
  NEW_RELIC_CONFIG,
} from '../../constants/newRelic';

export const InitializeNewRelic = () => {
  useEffect(() => {
    async function SetupNewRelic() {
      const { initializeBrowserAgent } = await import(
        '@vp/om-newrelic-tracker/agent'
      );

      initializeBrowserAgent({
        agentId: CART_NEWRELIC_BROWSER_AGENT_IDENTIFIER,
        config: NEW_RELIC_CONFIG,
      });
    }

    const isCypressUserAgent = userAgentDetect('Cypress');
    if (typeof window !== 'undefined' && !isCypressUserAgent) {
      SetupNewRelic();
    }
  }, []);

  return null;
};
